import { USER_KEY } from 'constants/keys'

export type AcaoDeSessao = 'SAIR' | 'ESCOLHER_ORGANIZACAO' | null

export const ROTA_DE_ESCOLHA = '/select-organization'

// why: o backend (F1) devolve 401 com `data.code` quando o modo da sessão manda
// aplicar. Em OBSERVAR nunca devolve. Mesmo campo do ACESSO_SUSPENSO (F0b).
export function acaoParaErroDeSessao(error: unknown): AcaoDeSessao {
  const resposta = (error as { response?: { status?: number; data?: { data?: { code?: string } } } } | undefined)
    ?.response
  if (resposta?.status !== 401) return null
  const code = resposta.data?.data?.code
  if (code === 'SESSAO_ORGANIZACAO_ALHEIA') return 'SAIR'
  if (code === 'SESSAO_SEM_ORGANIZACAO') return 'ESCOLHER_ORGANIZACAO'
  return null
}

// why: a tela de escolha usa o mesmo redirecionamento (useRedirects) e, com uma
// organização guardada, mandaria de volta ao painel: laço entre as duas telas.
// O usuário guardado pode ter a organização que o perfil antigo gravou sozinho
// (fallback anterior à F1); sem ela, o redirecionamento leva à escolha.
// invariant: nunca lança; armazenamento ilegível fica como está.
export function esquecerOrganizacaoGuardada(storage: Pick<Storage, 'getItem' | 'setItem'>): void {
  try {
    const guardado = storage.getItem(USER_KEY)
    if (!guardado) return
    const user = JSON.parse(guardado)
    if (!user || typeof user !== 'object') return
    storage.setItem(USER_KEY, JSON.stringify({ ...user, organization: null }))
  } catch {
    // why: armazenamento ilegível não impede a ida à escolha.
  }
}
